import { Pipe, PipeTransform, inject } from '@angular/core';
import { Fitter } from '@sc/data-access-models';
import { FitterNameDisplayContext } from '../models';
import { FitterNameDisplayService } from '../services';

@Pipe({
  name: 'fitterName',
  pure: true,
  standalone: true,
})
export class FitterNamePipe implements PipeTransform {
  private readonly fitterNameDisplayService = inject(FitterNameDisplayService);

  transform(
    fitter: Partial<Fitter>,
    overrideContext?: FitterNameDisplayContext,
    additionnalInfos?: any
  ) {
    return this.fitterNameDisplayService.getFitterNameTranslation(
      fitter,
      overrideContext,
      additionnalInfos
    );
  }
}
